'use client';
import { SupportHero }      from './SupportHero';
import { TopicGrid }        from './TopicGrid';
import { TrackStatusCard }  from './TrackStatusCard';
import { FAQSection }       from './FAQSection';
import { WarrantySection }  from './WarrantySection';
import { SupportCTA }       from './SupportCTA';

export const SupportPage = ({ replacementAllow = 7 }) => (
    <main>
        {/* 1 ── Help & Support Center hero */}
        <SupportHero />

        {/* 2 ── Check Your Warranty */}
        <WarrantySection />

        {/* 3 ── Track Repair Status */}
        <TrackStatusCard />

        {/* Browse by Topic heading */}
        <div className="container" style={{ padding: '2rem 1rem 0' }}>
            <div className="flex align-items-center gap-3">
                <div
                    className="flex align-items-center justify-content-center border-circle flex-shrink-0"
                    style={{ width: 40, height: 40, background: '#fff', border: '1.5px solid var(--primary-color)' }}
                >
                    <i className="pi pi-th-large" style={{ fontSize: '1rem', color: 'var(--primary-color)' }} />
                </div>
                <div>
                    <h2 className="m-0 font-bold text-900" style={{ fontSize: '1.25rem' }}>Browse by Topic</h2>
                    <p className="m-0 text-500" style={{ fontSize: '0.8rem' }}>Click any card to see all answers</p>
                </div>
            </div>
        </div>

        {/* 4 ── 6 clickable topic cards → opens FAQ modal or navigates */}
        <TopicGrid replacementAllow={replacementAllow} />

        {/* 5 ── Contact channels + My Orders CTA */}
        <SupportCTA />

        {/* 6 ── Full filterable FAQ accordion */}
        <FAQSection replacementAllow={replacementAllow} />
    </main>
);
